export default "__VITE_ASSET__BIT84HqM__"